import { Component, OnInit, Inject, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as $ from 'jquery';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { AccountVM } from '../../../../models/AccountMasterVM';
import { SeedReservationGrowerOrderData } from '../../../../models/SeedReservationGrowerOrderData';
import { CommonService } from '../../../../services/common/common.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { SliderModelService } from '../../../../services/infrastructure/sliderModel.service';
import { SeedReservationGrowerEditOrder } from '../seed-reservation-grower-edit-order/seed-reservation-grower-edit-order.component';
import { GrowerPdfGenerate } from '../../order/grower/grower-pdf-generate/grower-pdf-generate.component';
import { SeedReservationReconciliationService } from '../../../../services/seed/seed-reservation-reconciliation.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '../../../../services/infrastructure/config.service';


@Component({
  selector: 'app-seed-reservation-reconcile-grower-order',
  templateUrl: './seed-reservation-reconcile-grower-order.component.html',
  styleUrl: './seed-reservation-reconcile-grower-order.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ]
})

export class SeedReservationReconcileGrowerOrderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(SeedReservationGrowerEditOrder) addEditOrderDetail: SeedReservationGrowerEditOrder;
  @ViewChild('pdfGenerator') pdfGenerator: GrowerPdfGenerate;

  generatePdf() {
    this.pdfGenerator.generatePdf();
  }

  subscription = new Array<Subscription>();
  showGrowerInfo: Boolean;
  showAccInfo: Boolean;
  SelGrowerObj: SeedReservationGrowerOrderData;
  getGrowerOrderId: string;
  SelAccountObj: AccountVM;
  errorMsgs = new Array();
  currentErrorRow = 1;
  nextErrorId = 0;
  index = 0;
  updatedProductList: any;
  showErrorBlock = false;
  accountNo = 0;
  selectedGrowerAccId: any = 0;
  headerYear: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  emailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  accountEmail: string;
  isInvalidEmail = false;
  disableOnLock = false;
  matcher = new InputErrorStateMatcher(this.isInvalidEmail);
  isSubscriptionAccess = true;
  selGrowerOrderId: number;
  selGrowerAccountNumber: number;
  isFromHybridSlider = false;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  lastSliderPayload: any = null;

  constructor(
    @Inject('BASE_URL') public baseUrl: any,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private sliderModelService: SliderModelService,
    public broadcastService: BroadcastService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    public seedReservationReconciliationService: SeedReservationReconciliationService,
    private loaderService: LoaderService,
    public dialog: MatDialog,
    public configService: ConfigService,) {
    this.showAccInfo = false;
    this.showGrowerInfo = false;

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
  }

  ngOnInit(): void {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.push(this.sliderModelService.seedReservationReconcileSliderValue.subscribe(x => {

      if (x != null) {

        if (x.reopenFromGrowerOrder) {
          return;
        }
        this.loaderService.setLoaderStatus(true);
        this.errorMsgs = [];
        let paramGrowerOrderId = x.growerOrderId, paramAccountId = x.accountNo, gmk = x.gmk;
        this.isFromHybridSlider = !!x.isFromHybridSlider;
        this.lastSliderPayload = x;
        this.getGrowerAccount(x);
        this.selGrowerOrderId = +paramGrowerOrderId;
        this.accountNo = paramAccountId;
        this.selGrowerAccountNumber = paramAccountId;


      }

    }, (error => {
      LolLoggerService.error(error);
    })));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
      }
    }
  }

  // Get All Account List
  GetAccountList(accountNo: string) {
    this.subscription.push(this.seedReservationReconciliationService.getSeedResAccounts().subscribe((result: any[]) => {
      const data = result.filter(x => x.accountNumber == accountNo);
      if (data[0]) {
        const obj = data[0];
        this.seedReservationReconciliationService.AccountChange({
          accountName: obj.accountName,
          accountNumber: obj.accountNumber,
          accountType: obj.accountType,
          billingAddressType: obj.billingAddressType,
          address1: obj.address1,
          address2: obj.address2,
          emailAddress: obj.emailAddress,
          city: obj.city,
          state: obj.state,
          zipCode: obj.zipCode,
          isAccountRIB: false
        });
        this.SelAccountObj = this.seedReservationReconciliationService.SelectedAccountObj.value;
      }
    }, error => { LolLoggerService.error(error); }));
  }

  // Get All Grower Orders Accounts
  getGrowerAccount(obj: any) {
    this.getGrowerOrderId = obj.growerOrderId;

    this.subscription.push(this.seedReservationReconciliationService.getSeedResGrowerList(this.headerYear, '0', obj.growerOrderId?.toString(), obj.gmk?.toString())
      .subscribe((resp: any[]) => {
        const growerObj = new SeedReservationGrowerOrderData();
        if (+obj.growerOrderId > 0) {
          let data = resp.filter(x => x.growerOrderID == obj.growerOrderId);
          if (data[0]) {
            growerObj.growerOrderId = data[0].growerOrderID;
            growerObj.growerName = data[0].growerName;
            growerObj.orderID = data[0].orderNumber;
            growerObj.growerAddress = data[0].address;
            growerObj.city = data[0].city;
            growerObj.state = data[0].state;
            growerObj.zip = data[0].zipCode;
            growerObj.lastUpdatedAt = data[0].createTimestamp;
            growerObj.accountNo = data[0].shipToAccount;
            growerObj.orderType = data[0].orderType,
              growerObj.gln = data[0].growerGLN;
            growerObj.gmk = data[0].growerGMK;
            growerObj.EmailTo = data[0].emailAddress;
            growerObj.wfusB2BEnablement = data[0].wfusB2BEnablement;
            growerObj.isAccountRIB = data[0].isAccountRIB;


            if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
              const evolveAccess = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
              if (evolveAccess !== null && evolveAccess !== undefined && evolveAccess.resultData.length > 0) {
                const isActiveUser = evolveAccess.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
                if (isActiveUser.isSubscriptionAccess) {
                  this.accountEmail = data[0].emailAddress;
                }
              }
            }
          }
        } else {
          let data = resp.filter(x => x.growerGMK == obj.gmk);
          if (data[0]) {
            growerObj.growerOrderId = 0;
            growerObj.growerName = data[0].growerName;
            growerObj.orderID = "0";
            growerObj.growerAddress = data[0].address;
            growerObj.city = data[0].city;
            growerObj.state = data[0].state;
            growerObj.zip = data[0].zipCode;
            growerObj.accountNo = obj.accountNo?.toString();
            growerObj.gln = data[0].growerGLN;
            growerObj.gmk = data[0].growerGMK;
            growerObj.wfusB2BEnablement = data[0].wfusB2BEnablement;
            growerObj.isAccountRIB = data[0].isAccountRIB;
            growerObj.lastUpdatedAt = new Date();
          }
        }


        this.GetAccountList(growerObj.accountNo);
        this.seedReservationReconciliationService.GrowerChange(growerObj);
        this.SelGrowerObj = growerObj;
        this.disableOnLock = (+obj.growerOrderId > 0) ? (this.SelGrowerObj.orderType != 'WB' && this.SelGrowerObj.orderID !== '') : false;
        this.SelGrowerObj.seedReservationHeaderID = obj.seedReservationHeaderID;
        this.SelGrowerObj.productLine = obj.productLine;
        this.SelGrowerObj.marketingBrand = obj.marketingBrand;
        this.SelGrowerObj.selectedItemLIst = obj.productList;
        this.seedReservationReconciliationService.SelectedGrowerObj.value;
        this.selectedGrowerAccId = growerObj.accountNo;
        this.sliderModelService.selectedGrowerAccountId(this.selectedGrowerAccId);


      }, (error => {
        LolLoggerService.error(error);
      })));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.accountEmail = isActiveUser.emailId;
        }
      }
    }
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }
  // Design : Start
  setHeight() {
    const templateHeight = window.innerHeight - 150;
    $('.reconcile-grower-page').css('max-height', templateHeight + 'px');
  }
  // Design : End
  // Error handling : Start
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#orderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  hideCommonError() {
    this.showErrorBlock = false;
  }

  revertAllChanges() {
    this.addEditOrderDetail.RevertToPrevious([], false);
    this.hideCommonError();
  }

  // Validate the email address entered
  validateEmail() {
    this.isInvalidEmail = this.commonService.validateEmail(this.accountEmail, true);
    this.addEditOrderDetail.isInvalidEmail = false;
    if (this.isInvalidEmail) {
      this.addEditOrderDetail.isInvalidEmail = true;
    }
    else {
      this.SelGrowerObj.EmailTo = this.accountEmail;
    }
    this.matcher = new InputErrorStateMatcher(this.isInvalidEmail);
  }

  goBackToAddProduct() {
    if (!this.lastSliderPayload) {
      return;
    }
    const payload = {
      ...this.lastSliderPayload,
      productList: [],
      reopenFromGrowerOrder: true,
      isFromGoBack: true
    };
    this.sliderModelService.setSeedReservationReconcileChangeVal(payload);
    this.sliderModelService.activeSlider('seedReservationReconcileSlider');
  }

  navigateToReservationLanding() {
    var title = 'Leave without saving?';
    var message = '';
    var dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(result => {
      // If user selected Yes
      if (result == true) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
        //this.seedReservationService.setseedReservationId(this.seedReservationId, true);
        this.router.navigate(['/seed-reservation-landing']);
      }
    }));
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
